import * as React from "react";

interface RelodeRepProps {
    image: string
    name: string
    children?: React.ReactNode
}

export const RelodeRep = (props: RelodeRepProps) => (
    <div className="c-relode-rep">
        <img className="c-relode-rep__image" src={props.image} alt={"image: " + props.name} />
        <div className="c-relode-rep__info">
            <div className="c-relode-rep__name">{props.name}</div>
            {props.children && <div className="c-relode-rep__actions">{props.children}</div>}
        </div>
    </div>
);

export default RelodeRep;
